import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { BusCheckList } from '../../../store/models/bus-check-list.model';
import { BusCheckData } from '../_types/bus-check-data';
import { BusCheckItem } from '../_types/bus-check-item';

@Injectable({
  providedIn: 'root'
})
export class BusCheckListService {

  apiBase: string = environment.busCheckApiUrl;
  apiBusCheckListTemplate: string = '/bus_check_list_template';
  apiBusCheckItems: string = '/bus_check_items';
  apiBusCheck: string = '/bus_check';

  constructor(private httpClient: HttpClient) { }

  // --- Bus Check List Template ---

  getAllBusCheckListTemplates(): Observable<BusCheckList[]> {
    const url = this.apiBase + this.apiBusCheckListTemplate;
    return this.httpClient.get<BusCheckList[]>(url);
  }

  getBusCheckListTemplateById(templateId: number): Observable<BusCheckList> {
    const url = this.apiBase + this.apiBusCheckListTemplate + templateId;
    return this.httpClient.get<BusCheckList>(url);
  }

  // Botón 1: Master Template - añade preguntas generales a nivel global (solo governance)
  addMasterTemplate(data: Partial<BusCheckList>): Observable<BusCheckList> {
    const url = this.apiBase + this.apiBusCheckListTemplate + "/master_template";
    return this.httpClient.post<BusCheckList>(url, data);
  }

  // Botón 2: Setup - obtiene datos del master template para un idioma y región específicos
  setupFromMasterTemplate(language: string, regionId: number): Observable<BusCheckList[]> {
    const url = `${this.apiBase}${this.apiBusCheckListTemplate}/set_up/${language}/${regionId}`;
    return this.httpClient.post<BusCheckList[]>(url, {});
  }

  // Botón 3: Añadir tema regional - añade pregunta específica para una región
  addRegionalTopic(data: BusCheckList): Observable<BusCheckList> {
    const url = this.apiBase + this.apiBusCheckListTemplate;
    return this.httpClient.post<BusCheckList>(url, data);
  }

  updateBusCheckListTemplate(templateId: number, data: BusCheckList): Observable<BusCheckList> {
  const url = `${this.apiBase}${this.apiBusCheckListTemplate}/${templateId}`;
  return this.httpClient.put<BusCheckList>(url, data);
}

  deleteBusCheckListTemplate(templateId: number): Observable<any> {
    const url = this.apiBase + this.apiBusCheckListTemplate + '/' + templateId;
    return this.httpClient.delete(url);
  }

  // --- Bus Check Item ---

  getAllBusCheckItems(busCheckId: number): Observable<BusCheckItem[]> {
    const url = this.apiBase + this.apiBusCheckItems + '/getAll/' + busCheckId;
    return this.httpClient.get<BusCheckItem[]>(url);
  }

  getBusCheckItemById(itemId: number): Observable<BusCheckItem> {
    const url = this.apiBase + this.apiBusCheckItems + '/set_up' + itemId;
    return this.httpClient.get<BusCheckItem>(url);
  }

  updateBusCheckItem(itemId: number, data: BusCheckItem): Observable<BusCheckItem> {
    const url = this.apiBase + this.apiBusCheckItems + '/set_up' + itemId;
    return this.httpClient.put<BusCheckItem>(url, data);
  }
  
  // --- Bus Check ---

  initBusCheckList(busCheckData: BusCheckData) {
    const url = this.apiBase + this.apiBusCheck + '/create';
    return this.httpClient.post<BusCheckList>(url, busCheckData);
  }

  updateBusCheckListItem(busCheckItem: BusCheckItem) {
    const url = this.apiBase + this.apiBusCheckItems + '/' +  busCheckItem.id;
    return this.httpClient.put<BusCheckItem>(url, busCheckItem);
  }

  updateBusCheckData(id: number, busCheckData: BusCheckData) {
    const url = this.apiBase + this.apiBusCheck + '/' + id;
    return this.httpClient.put<BusCheckData>(url, busCheckData);
  }

  updateOtherFindings(id: number, busCheckData: BusCheckData): Observable<BusCheckData> {
    const url = this.apiBase + this.apiBusCheck + '/other_findings/' + id;   
    return this.httpClient.put<BusCheckData>(url, busCheckData);
  }

  getBusCheckDataById(id: number): Observable<BusCheckData> {
    const url = this.apiBase + this.apiBusCheck + '/' + id;
    return this.httpClient.get<BusCheckData>(url);
  }

  createBusCheckDocuSign(busCheckId: number, docuSigns: any[]): Observable<any> {
    const url = `${this.apiBase}/bus_check_docu_sign/${busCheckId}`;
    return this.httpClient.post<any>(url, docuSigns);
  }

  getBusCheckFooter(busCheckId: number): Observable<any> {
    const url = `${this.apiBase}/bus_check/bus_check_footer/${busCheckId}`;
    return this.httpClient.get<any>(url);
  }

  updateBusCheckFooter(busCheckId: number, footerData: any): Observable<any> {
    const url = `${this.apiBase}/bus_check/${busCheckId}`;
    return this.httpClient.put<any>(url, footerData);
  }

  getDrafts(auditor: string): Observable<BusCheckData[]> {
    const url = this.apiBase + this.apiBusCheck + `/last_draft/${auditor}`;
    return this.httpClient.get<BusCheckData[]>(url);
  }

  deleteBusCheck(id: number): Observable<any> {
    const url = this.apiBase + this.apiBusCheck + '/' + id;
    return this.httpClient.delete(url);
  }

}